export namespace DomUtils {
  // So that the header, page will not scroll with content
  export function setAllParentsToFullHeight(element: HTMLDivElement) {
    let nextElement = element.parentElement;
    while (nextElement) {
      nextElement.style.height = "100%";
      nextElement = nextElement.parentElement;
    }
  }
}



// WEBPACK FOOTER //
// ./utils/DomUtils.ts